<template lang="html">
    <div class="amap">
        <div class="clod" @click="close()"> × </div>
        <div id="mapContainer"></div>
    </div>
</template>

<script>
    import AMap from  'AMap'
    export default {
        props: {
            AMaps:{
                type: Boolean,
                default: false,
            }
        },
        methods: {
            init(obj) {
                let map = new AMap.Map("mapContainer", {
                    zoom: 18,
                    center:[obj.data.longitude, obj.data.latitude]
                });
                let marker = new AMap.Marker({
                    map:map,
                    position:[obj.data.longitude, obj.data.latitude]
                })
                marker.setLabel({
                    offset: new AMap.Pixel(-70, 40),
                    content: "点击上分标记点打开高德地图"
                });
                marker.on('click',function(){
                    marker.markOnAMAP({
                        // name:'首开广场',
                        position:marker.getPosition()
                    })
                })
                map.addControl(new AMap.ToolBar());
            },

            close(){
                this.$router.push({
                    path : '/',
                    query:{
                        id: this.$route.query.id,
                    }
                });
            }
        },
        mounted() {
            this.$http({
                url: '/activity/detail',
                method: 'get',
                params: {
                    activity_id : this.$route.query.id,
                },
            }).then( (res) => {
                this.init(res);
            })
        },
    }
</script>

<style lang="css" scoped>
.clod{
    z-index: 10;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    position: fixed;
    right: 10px;
    top: 10px;
    font-size: 40px;
    border-radius: 10px;
    color: #3F454B;
    background-color: rgba(216, 216, 216, 0.5);

}
#container {
    width: 100%;
    height: 500px;
}
</style>
